findCustomerName = (id, customerList) => {
    var name = "Client inconnu";
    customerList.forEach(element => {
        if (element.id === id) {
            name = element.name
            return name;
        }
    });
    return name;
}

module.exports = findCustomerName;
